import { CampaignState } from '@intentsify/types';
export const isTalProcessing = (state) => {
    const nonProcessingStates = [
        CampaignState.Created,
        CampaignState.Creating,
        CampaignState.Unspecified,
        CampaignState.TalDomainsValidationProcessed,
        CampaignState.TalFileLoadProcessed,
    ];
    return !nonProcessingStates.includes(state) && !state.includes('error');
};
//# sourceMappingURL=isTalProcessing.js.map